import axios from "axios";
import Request from "./Request";
import urls from "./urls";

const apiRequest = new Request(
  () => {},
  () => {},
  () => {}
);

export const sendotpForLogin = (params) => {
  return apiRequest.post(`${urls.API_BASEPATH}${urls.loan.SEND_OTP}`, params);
};
export const verifyotpForLogin = (params) => {
  return apiRequest.post(`${urls.API_BASEPATH}${urls.loan.VERIFY_OTP}`, params);
};
export const verifyPan = (params) => {
  return apiRequest.post(`${urls.API_BASEPATH}${urls.loan.VERIFY_PAN}`, params);
};

export const getDashboardData = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.GET_DASHBOARD}`,
    params
  );
};

export const savePerssonalDetails = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.PERSONAL_DETAILS}`,
    params
  );
};

export const savePerssonalAddress = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.ADDRESS_DETAILS}`,
    params
  );
};
export const getStateCityPincode = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.STATE_CITY_PINCODE}`,
    params
  );
};
export const getIncomeDetails = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.INCOME_DETAILS}`,
    params
  );
};
export const uploadProfilePhoto = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.UPLOAD_PROFILE_PIC}`,
    params
  );
};

export const saveDocuments = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.CUSTOMER_DOCUMENT}`,
    params
  );
};
export const ckeckEligibility = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.CHECK_ELIGIBILITY}`,
    params
  );
};
export const aboutCompany = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.ABOUT_COMPANY}`,
    params
  );
};
export const calculateLoan = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.CALCULATE_LOAN}`,
    params
  );
};
export const generateLoan = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.GENERATE_LOAN}`,
    params
  );
};

export const saveReferenceDetails = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.REFERENCE_DETAILS}`,
    params
  );
};


export const userdata = (params) => {
  return apiRequest.post(`${urls.API_BASEPATH}${urls.loan.USER_DATA}`, params);
};

export const saveProfile = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.PROFILE_PIC}`,
    params
  );
};

export const allLeads = (params) => {
  return apiRequest.post(`${urls.API_BASEPATH}${urls.loan.ALL_LEADS}`, params);
};

export const loanDetail = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.LOAN_DETAIL}`,
    params
  );
};

export const orderId = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.GENERATE_ORDER_ID}`,
    params
  );
};

export const accountAggregator = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.ACCOUNT_AGGREGATOR}`,
    params
  );
};

export const requiredDocs = (params) => {
  return apiRequest.post(
    `${urls.API_BASEPATH}${urls.loan.MANDATORY_DOCS}`,
    params
  );
};

// Video KYC and Account Aggregator by emailed link. These calls are public (the token in the link is the credential), so
// they use axios directly: no Authtoken and none of the login handling of the shared Request wrapper.
const publicLinkPost = async (path, body, config) => {
  try {
    const resp = await axios.post(`${urls.API_BASEPATH}${path}`, body, config);
    return resp?.data;
  } catch (error) {
    return error?.response?.data || null;
  }
};

export const videoKycInfo = (token) =>
  publicLinkPost(urls.loan.VIDEO_KYC_INFO, { token });

// onProgress receives 0-100
export const videoKycSubmit = (token, blob, ext, onProgress, location) => {
  const form = new FormData();
  form.append("token", token);
  form.append("video", blob, `video_kyc.${ext}`);
  if (location) {
    form.append("latitude", String(location.latitude));
    form.append("longitude", String(location.longitude));
    if (location.accuracy !== null && location.accuracy !== undefined) form.append("accuracy", String(location.accuracy));
  }
  return publicLinkPost(urls.loan.VIDEO_KYC_SUBMIT, form, {
    onUploadProgress: (e) => {
      if (e.total && onProgress) onProgress(Math.round((e.loaded * 100) / e.total));
    },
  });
};

export const aaLinkInfo = (token) =>
  publicLinkPost(urls.loan.AA_LINK_INFO, { token });

// returnOrigin: the origin the page is on (www / non-www), so Ignosis sends the customer back to it
export const aaLinkStart = (token, returnOrigin) =>
  publicLinkPost(urls.loan.AA_LINK_START, { token, return_origin: returnOrigin });
